module.exports = __webpack_public_path__ + "static/media/edit.609c07fc.svg";